import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'

class SurveySettingEdit extends Component {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.apiUrl = Config.adminApiUrl.surveySetting
    this.userRole = 'admin'
  }
  getInitialState () {
    const dt = new Date()
    return {
      isLoaded: false,
      isNew: true,
      id: '',
      year: dt.getFullYear(),
      title: '型枠大工雇用実態調査',
      shimeFlg: true,
    }
  }
  componentDidMount() {
    const { id } = this.props.match.params
    if (id) {
      this.loadServey(id)
    } else {
      this.setState({ isLoaded: true })
    }
  }
  loadServey(id) {
    const onSuccess = (res) => {
      // APIから取得したデータをstateに反映
      const surveyData = res.body.data[0]
      this.setState({
        id: surveyData.id,
        year: surveyData.year,
        title: surveyData.title,
        shimeFlg: surveyData.shimeFlg,
        isNew: false,
        isLoaded: true,
      })
    }
    const params = {
      command: 'getDetail',
      surveyValue: { id: id },
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveServey () {
    const {params} = this.props.match
    const id = params.id
    const servey = this.state
    const serveyYear = Number(servey.year)
    if (serveyYear < 1000) {
      Window.alert('西暦を4桁で入力してください')
      return false
    }
    let updateOrInsert
    if (id) { // 更新
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: servey.id,
          year: serveyYear,
          title: servey.title,
          shimeFlg: servey.shimeFlg,
          isNew: false
        }
        return result
      }
    } else { // 新規登録
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: this.uuid(),
          year: serveyYear,
          title: servey.title,
          shimeFlg: true,
          isNew: true,
        }
        return result
      }
    }
    const onSuccessToGet = (res) => {
      const surveyValue = updateOrInsert(res.body)
      let paramsToSet = [];
      if(surveyValue.isNew === true) {
        paramsToSet = {
          command: 'add',
          surveyValue: surveyValue
        }
      } else {
        paramsToSet = {
          command: 'set',
          surveyValue: surveyValue
        }
      }
      const onSuccessToPost = (res) => {
        Window.alert('保存しました', () => {
          this.props.history.push('/admin/survey_setting')
          Window.closeDialog()
        })
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    }
    const paramsToGet = {
      command: 'get'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
  }
  delServey () {
    const servey = this.state
    const paramsToSet = {
      command: 'del',
      surveyValue: servey
    }
    const onSuccessToPost = (res) => {
      Window.alert('削除しました', () => {
        this.props.history.push('/admin/survey_setting')
        Window.closeDialog()
      })
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/admin/survey_setting')
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  renderSurveyDetail(state) {
    const survey = state;
    const changed = (name, e) => {
      const value = e.target.type === 'radio' ? e.target.value === 'true' : e.target.value;
      this.setState({ [name]: value });
    };
    const title = state.isNew ? '新規登録' : '変更';
    const surveyTitle = survey.title ? survey.title : '型枠大工雇用実態調査';

    // 現在の年度を基に5年間のオプションを生成
    const currentYear = survey.year || new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear + i);
    const selectedYear = survey.year || currentYear;

    if(survey.isNew) {
      return (
        <fieldset>
          <legend>アンケート情報 - {title}</legend>
          <br />
          <div className='control-group row'>
            <label className='span3'>実施年度 <span className='required'>*</span></label>
            <div className='span13 row'>
              <select 
                className='span2' 
                value={selectedYear}
                onChange={e => changed('year', e)}
              >
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
              <span className='kw-info-unit'>年</span>
            </div>
          </div>
          <div className='control-group row'>
            <label className='span3'>タイトル <span className='required'>*</span></label>
            <div className='span8'>
              <input type='text' className='span8' value={surveyTitle} onChange={e => changed('title', e)} />
            </div>
          </div>
        </fieldset>
      );
    } else {
      return (
        <fieldset>
          <legend>アンケート情報 - {title}</legend>
          <br />
          <div className='control-group row'>
            <label className='span3'>実施年度 <span className='required'>*</span></label>
            <div className='span13 row'>
              <select 
                className='span2' 
                value={selectedYear}
                onChange={e => changed('year', e)}
              >
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
              <span className='kw-info-unit'>年</span>
            </div>
          </div>
          <div className='control-group row'>
            <label className='span3'>タイトル <span className='required'>*</span></label>
            <div className='span8'>
              <input type='text' className='span8' value={surveyTitle} onChange={e => changed('title', e)} />
            </div>
          </div>
          <div className='control-group row'>
            <label className='span3'>アンケート締め対応 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'>
                <input 
                  type='radio' 
                  id='Recieve' 
                  name='shimeFlg' 
                  value='true' 
                  checked={survey.shimeFlg === true} 
                  onChange={e => changed('shimeFlg', e)} 
                />
                アンケートを締める
              </label>
              <label htmlFor='NonRecieve' className='kw-pointer'>
                <input 
                  type='radio' 
                  id='NonRecieve' 
                  name='shimeFlg' 
                  value='false' 
                  checked={survey.shimeFlg === false} 
                  onChange={e => changed('shimeFlg', e)} 
                />
                アンケートを締めない
              </label>
            </div>
          </div>
          <div className='control-group row'>
            <label className='span3'>アンケートURL</label>
            <div className='span9'>
              <a href={`${window.location.origin}/company_user/survey_answer_nl/${survey.id}`} 
                target="_blank" rel="noopener noreferrer">
                {`${window.location.origin}/company_user/survey_answer_nl/${survey.id}`}
              </a>
            </div>
          </div>
        </fieldset>
      );
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    switch (name) {
      case 'save':
        this.saveServey()
        break
      case 'delete':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.delServey()
        })
        break
      case 'cancel':
        this.props.history.push('/admin/survey_setting')
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const surveyDetail = this.renderSurveyDetail(this.state)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>アンケート情報 - {title}<br /><small>こちらでアンケート情報を{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onFormButtonClicked('delete', e)} ><i className='icon-remove icon-large' /><span>削除</span></button></li>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                <div className='alert alert-block alert-info'>
                  <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
                </div>
                {surveyDetail}
                <footer className='form-actions' id='submit-actions'>
                  <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
                  <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
                </footer>
              </div>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default SurveySettingEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveySettingEdit.js